export default "__VITE_ASSET__rLKk6zzh__"